"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartAsidePromoCode = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
const Input_1 = require("./../Input");
const react_2 = require("@headlessui/react");
const Button_1 = require("./../Button");
const translations_1 = require("../../i18n/translations");
function CartAsidePromoCode(_a) {
    var { className, linkProps, linkClassName, handleAddPromoCode, handleRemovePromoCode, promotionCodes, isLoading, locale = 'en' } = _a, props = __rest(_a, ["className", "linkProps", "linkClassName", "handleAddPromoCode", "handleRemovePromoCode", "promotionCodes", "isLoading", "locale"]);
    const { asidePromoAddLink, asidePromoAppliedLabel, asidePromoRemove, asidePromoInputLabel, asidePromoCancel, asidePromoApply, } = translations_1.cartAsideContent[locale];
    const [promoCode, setPromoCode] = (0, react_1.useState)('');
    const [promoError, setPromoError] = (0, react_1.useState)('');
    const promoLoadedCallback = (close, error) => {
        if (error) {
            setPromoError(error);
            setTimeout(() => {
                setPromoError('');
            }, 6000);
        }
        setPromoCode('');
        close();
    };
    const onPromoAdd = (close) => {
        handleAddPromoCode(promoCode, promoLoadedCallback, close);
    };
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('w-full max-w-full border-b border-gray-e pb-4 mb-4') }, props),
        !isLoading && (promotionCodes === null || promotionCodes === void 0 ? void 0 : promotionCodes.length) === 0 && (react_1.default.createElement(react_2.Disclosure, null, ({ open, close }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_2.Disclosure.Button, { className: `pb-2 inline-block decoration-solid text-gray-74 hover:text-gray focus:text-text-gray focus:underline hover:underline text-sm transition-colors ${!open ? 'hidden' : ''}` }, asidePromoCancel),
                react_1.default.createElement(react_2.Disclosure.Button, { className: `pb-2 inline-block decoration-solid text-blue hover:text-blue-hover focus:text-blue-hover focus:underline hover:underline text-sm transition-colors ${open ? 'hidden' : ''}` },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", { "aria-hidden": true }, "+"),
                        " ",
                        asidePromoAddLink))),
            react_1.default.createElement(react_2.Disclosure.Panel, { className: "flex flex-row w-full mb-3" },
                react_1.default.createElement("label", { htmlFor: "promo-code-add", className: "sr-only" }, asidePromoInputLabel),
                react_1.default.createElement(Input_1.Input, { id: "promo-code-add", "data-testid": "promo-code-add-input", className: (0, classnames_1.default)('py-1.5 grow w-full'), onChange: (e) => setPromoCode(e.target.value), 
                    // eslint-disable-next-line
                    autoFocus: true, value: promoCode, onKeyPress: (event) => {
                        if (event.key === 'Enter') {
                            onPromoAdd(close);
                        }
                    } }),
                react_1.default.createElement(Button_1.Button, { className: "rounded-full ml-2 font-sofia", variant: "blue", onClick: () => onPromoAdd(close) }, asidePromoApply)))))),
        promoError && (react_1.default.createElement("div", { className: "bg-red-alertbg text-red-alerttext text-sm rounded-md px-4 py-3 mb-2", role: "alert" },
            react_1.default.createElement("p", null, promoError))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: "sr-only" }, asidePromoAppliedLabel),
            promotionCodes.map((promo) => (react_1.default.createElement("ul", { key: promo, className: "flex flex-wrap justify-start" },
                react_1.default.createElement("li", { className: "flex flex-row flex-nowrap text-sm border-2 border-gray-a pl-2 pr-1.5 py-1 rounded-full" },
                    react_1.default.createElement(fa_1.FaTag, { className: "text-green mr-1 relative text-xs relative top-1", "aria-hidden": true }),
                    react_1.default.createElement("span", { className: "font-bold mr-1" }, promo),
                    react_1.default.createElement("button", { className: "text-gray-74 ml-2 transition-colors hover:text-black focus:text-black", onClick: () => handleRemovePromoCode(promo), "data-testid": `promo-code-tag-close-${promo}` },
                        react_1.default.createElement("span", { className: "sr-only" }, asidePromoRemove),
                        react_1.default.createElement(fa_1.FaTimes, { "aria-hidden": true })))))))));
}
exports.CartAsidePromoCode = CartAsidePromoCode;
